export const setIntervalImmediately = (
  func: Function,
  interval: number
): number => {
  func();
  return setInterval(func, interval);
};
